module.exports = __webpack_public_path__ + "img/tempo-de-casa.925194d6.svg";